<template>
  <div class="form" :style="{ '--w': width }">
    <el-form :model="form_data" :label-width="labelWidth" :style="form_style">
      <el-form-item :class="[mode == 'search' ? 'noBottom' : '']" v-for="item in form" :key="item.key"
        :label="item.label">
        <el-input :size="size" v-if="item.type === 'input'" v-model="form_data[item.key]"
          :placeholder="item.placeholder || '请输入'" :maxlength="item.maxlength || '30'" />
        <el-date-picker v-if="item.type === 'datetimerange'" type="datetimerange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" v-model="form_data[item.key]" :size="size" />
        <el-cascader class="el-cascader" v-if="item.type === 'cascader'" filterable v-model="form_data[item.key]"
          :options="item.list" :props="item.config" :size="size" />
        <el-select v-if="item.type === 'select'" filterable v-model="form_data[item.key]"
          :placeholder="item.placeholder || '请选择'" :size="size">
          <el-option v-for="(option, index) in item.list" :key="index" :label="option[label_text(item)]"
            :value="option[label_id(item)]" />
        </el-select>
        <div v-if="item.type === 'select_more'">
          <el-select :popper-class="'_' + item.key" filterable :filter-method="(val) => filterSelect(item.key, val)"
            v-model="form_data[item.key]" :placeholder="item.placeholder || '请选择'" :data-key="item.key"
            v-more="() => loadMoreSelect(item.key)" :clearable="true" :size="size">
            <el-option v-for="(option, index) in item.list" :key="index" :label="option[label_text(item)]"
              :value="option[label_id(item)]" :class="
                item.config && item.config.type == 'slot' ? 'auth_height' : ''
              ">
              <div v-if="item.config && item.config.type == 'slot'">
                <slot :name="item.key" :data="option"></slot>
              </div>
            </el-option>
          </el-select>
        </div>
        <div v-if="item.type === 'number_range'">
          <!-- 数字区间 -->
          <div class="number_range">
            <el-input :size="size" @input="(e)=>handleNumberInput(form_data[item.key],e)" type="number"
              v-model="form_data[item.key][0]" :placeholder="item.placeholder[0] || '请输入'"></el-input>
            <span class="number_range_split">~</span>
            <el-input :size="size" @input="(e)=>handleNumberInput(form_data[item.key],e)" type="number"
              v-model="form_data[item.key][1]" :placeholder="item.placeholder[1] || '请输入'"></el-input>
          </div>
        </div>
      </el-form-item>
      <el-form-item :class="[mode == 'search' ? 'noBottom' : '']" v-if="mode == 'search'">
        <el-button type="primary" :size="size" @click="handleSearch()">筛选</el-button>
        <el-button type="primary" :size="size" @click="handleReset()">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import _ from "lodash";
import InfiniteScroll from "@/directives/infiniteScroll.js";
import { debounce } from "@/util/util.js";

export default {
  props: {
    mode: {
      type: String,
      default: "search",
    },
    form: {
      type: Array,
      default: () => {
        return [];
      },
    },
    labelWidth: {
      type: String,
      default: "100px",
    },
    size: {
      type: String,
      default: "small",
    },
    width: {
      type: String,
      default: "250px",
    },
    form_style: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  directives: {
    more: InfiniteScroll,
  },
  data() {
    return {
      form_data: {},
      form_data_hash: {},
    };
  },
  methods: {
    dealFormData(form) {
      for (const key in this.form_data) {
        if (Array.isArray(this.form_data[key])) {
          this.form_data[key].forEach((item, index) => {
            this.$set(this.form_data[key], index, '')
          })
        }
      }
      form.forEach((item) => {
        this.$set(
          this.form_data,
          item.key,
          item.d_value !== undefined ? item.d_value : ""
        );
        this.$set(this.form_data_hash, item.key, {
          type: item.type,
          d_value: item.d_value,
          result: item.result,
        });
      });
    },
    handleSearch(is_deal_params) {
      let obj = _.cloneDeep(this.form_data);
      for (const key in obj) {
        let data = obj[key];
        if (!data && this.form_data_hash[key].type !== "select") {
          delete obj[key];
          continue;
        }
        if (
          this.form_data_hash[key].type === "select" &&
          data === this.form_data_hash[key].d_value
        ) {
          delete obj[key];
          continue;
        }
        if (typeof data === "array" || typeof data === "object") {
          if (!data.length) delete obj[key];
          if (
            data.length &&
            this.form_data_hash[key].type === "datetimerange"
          ) {
            data[0] = Math.ceil(data[0].getTime() / 1000);
            data[1] = Math.ceil(data[1].getTime() / 1000);
            if (data[0] == data[1]) {
              data[1] += 60 * 60 * 24 - 1;
            }
            // 如果时间戳不是以数组形式传递
            if (this.form_data_hash[key].result) {
              for (const r in this.form_data_hash[key].result) {
                let i = this.form_data_hash[key].result[r];
                obj[r] = data[i];
              }
            }
          }
        }
        if (this.form_data_hash[key].type === "number_range") {
          data[0] = Number(data[0])
          data[1] = Number(data[1])
          data = data.sort((a, b) => a - b);
          if (!data[0] && !data[1]) {
            delete obj[key]
          }
        }
        if (data === undefined) delete obj[key];
      }
      if (is_deal_params) return obj;
      this.$emit("search", obj);
    },
    handleReset() {
      this.dealFormData(this.form);
      this.handleSearch();
    },
    label_text(data) {
      if (data.config && data.config.label) return data.config.label;
      return "name";
    },
    label_id(data) {
      if (data.config && data.config.value) return data.config.value;
      return "id";
    },
    loadMoreSelect(key) {
      this.$emit("next", key);
    },
    deal() {
      return this.handleSearch(true);
    },
    filterSelect(key, val) {
      // 使用防抖函数包装emit操作
      let that = this;
      if (!this.filterSelectDebounced) {
        this.filterSelectDebounced = debounce((key, val) => {
          that.$emit("select", { key, val });
        }, 300);
      }
      this.filterSelectDebounced(key, val);
    },
  },
  created() {
    this.unwatchCounter = this.$watch(
      "form",
      (newVal, oldVal) => {
        if (newVal.length) {
          this.dealFormData(newVal);
        }
      },
      { immediate: true }
    );
  },
  beforeDestroy() {
    if (this.unwatchCounter) this.unwatchCounter();
  },
};
</script>

<style lang="less" scoped>
.form {
  width: 100%;
  .el-input,
  .el-select,
  .number_range {
    width: var(--w);
  }
  /deep/ .el-cascader {
    width: var(--w);
  }
}
.number_range {
  display: flex;
  align-items: center;
  .number_range_split {
    margin: 0 10px;
  }
  .el-input {
    flex: 1;
  }
}
.noBottom {
  margin-bottom: 10px !important;
}
.ml_20 {
  margin-left: 20px;
}
.auth_height {
  height: auto !important;
  margin-bottom: 4px;
}
</style>
